import comp from "./Accordion";
export default comp;
